module.exports = __webpack_public_path__ + "img/private-napolimania-pasta-2.6be65459.jpg";